<template>
  <v-navigation-drawer
    id="settings-drawer"
    v-model="settings"
    disable-route-watcher
    fixed
    hide-overlay
    temporary
    width="300"
    right
  >
  <v-toolbar
    class="v-bar--underline"
    flat
  >
    <h2>{{ $t('Setting') }}</h2>
    <v-spacer />
    <v-btn
      icon
      @click="settings = !settings"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-toolbar>
  <!-- Theme -->
  <default-setting-items :title="$t('Theme')" :items="themes" :defaultValue="theme"/>

  <!-- Theme -->
  <default-setting-items :title="$t('Language')" :items="languages" :defaultValue="locale"/>
  </v-navigation-drawer>
</template>

<script>
import { get, sync, call } from 'vuex-pathify'
import DefaultSettingItems from './SettingItems'

export default {
  name: 'DefaultSettings',
  components: { DefaultSettingItems },
  computed: {
    ...sync('app', [
      'settings'
    ]),
    ...sync('app', [
      'theme',
      'locale'
    ]),
    ...get('common', [
      'system_languages',
      'system_themes'
    ]),
    themes () {
      const cb = (payload) => this.setTheme(payload)
      const arr = []
      this.system_themes.forEach(function (element) {
        arr.push({
          ...element,
          cb
        })
      })
      return arr
    },
    languages () {
      const cb = (payload) => this.setLocale(payload)
      const arr = []
      this.system_languages.forEach(function (element) {
        arr.push({
          ...element,
          cb
        })
      })
      return arr
    }
  },
  methods: {
    ...call('app', [
      'setTheme',
      'setLocale'
    ])
  }
}
</script>
